import { useCheckPaymentTerm } from 'pages/home/ribbon/components/sections/product/components/cod-payment/hooks';

import { useGetMemberInfo } from 'hooks/useGetMemberInfo';

export const useCheckPaymentTermMonthAndMemberStatusCreditReview = () => {
  const { isMonthlyTerm } = useCheckPaymentTerm();
  const { memberInfo } = useGetMemberInfo();

  return isMonthlyTerm && memberInfo?.status?.toLowerCase() === 'credit review';
};
